import { type IApiResponse, type IElectionCycleByIDState } from '@/helpers/types';
import { type IElectionCycleState } from '@/interface/state/IElectionState';
import { getCoreQuery, type IGetQuery } from '@/store/actions/api-utils';
import { type ICreateElectionCycle, type IUpdateElectionCycle } from '@/store/actions/core/election-cycle';

import { coreApiSlice } from '../apiSlice';

export const electionCycleApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getElectionCycle: builder.query<IApiResponse<IElectionCycleState[]>, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/ElectionCycle${getCoreQuery(paged, ...(query || []))}`,
			}),
		}),
		createElectionCycle: builder.mutation<IApiResponse, ICreateElectionCycle>({
			query: (data) => ({
				method: 'POST',
				url: '/ElectionCycle',
				data,
			}),
		}),
		updateElectionCycle: builder.mutation<IApiResponse, IUpdateElectionCycle>({
			query: (data) => ({
				method: 'PUT',
				url: '/ElectionCycle/update',
				data,
			}),
		}),
		getElectionCycleById: builder.query<IApiResponse<IElectionCycleByIDState>, { id: string }>({
			query: ({ id }) => ({
				url: `/ElectionCycle${id}`,
			}),
		}),
		deleteElectionCycle: builder.mutation<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				method: 'DELETE',
				url: `/ElectionCycle/delete/${id}`,
			}),
		}),
	}),
});

export const {
	useGetElectionCycleQuery,
	useLazyGetElectionCycleQuery,
	useDeleteElectionCycleMutation,
	useGetElectionCycleByIdQuery,
	useLazyGetElectionCycleByIdQuery,
	useUpdateElectionCycleMutation,
	useCreateElectionCycleMutation,
} = electionCycleApiSlice;

export const selectGetElectionCycleById = electionCycleApiSlice.endpoints.getElectionCycleById.select({ id: '' });
